import { supabase } from "@/integrations/supabase/client";

// AUDIT-LOG-CHECK (I.160): só os quatro tipos aceitos pelo CHECK de audit_logs; evento novo vai em `details`
export type AuditActionType = 'CRIAÇÃO' | 'EXCLUSÃO' | 'ATUALIZAÇÃO' | 'VISUALIZAÇÃO';
export type AuditModule = 'FINANCEIRO' | 'COMPRAS' | 'VENDAS' | 'ESTOQUE' | 'CADASTROS' | 'LOCAÇÕES' | 'SERVIÇOS' | 'LOGÍSTICA' | 'CRM' | 'CONFIGURAÇÕES';

interface LogActionParams {
    action: AuditActionType;
    module: AuditModule;
    entityType: string;
    entityId?: string;
    description: string;
    details?: Record<string, any>;
    userId?: string;
    companyId?: string;
}

export const auditService = {
    logAction: async ({ action, module, entityType, entityId, description, details, userId, companyId }: LogActionParams) => {
        try {
            let uid = userId;
            let cid = companyId;

            if (!uid) {
                const { data: { user } } = await supabase.auth.getUser();
                if (!user) {
                    console.warn('⚠️ [AuditService] Tentativa de log sem usuário autenticado');
                    return;
                }
                uid = user.id;
            }

            if (!cid) {
                const { data: profile } = await supabase
                    .from('profiles')
                    .select('company_id')
                    .eq('user_id', uid)
                    .single();

                if (!profile?.company_id) {
                    console.warn('⚠️ [AuditService] Usuário sem company_id');
                    return;
                }
                cid = profile.company_id;
            }

            const { error } = await supabase.from('audit_logs').insert({
                company_id: cid,
                user_id: uid,
                action_type: action,
                module: module,
                entity_type: entityType,
                entity_id: entityId,
                description: description,
                details: details
            });

            if (error) {
                console.error('❌ [AuditService] Falha ao registrar log:', error);
            }
        } catch (err) {
            console.error('🚨 [AuditService] Erro crítico:', err);
        }
    }
};
